import React,{ Component } from 'react';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import AdjoyTermsAndConditions from '../../OnboardingSignup/components/AdjoyTermsAndConditions';

import { urlRoot } from '../../../shared/utils';

//eslint-disable-next-line
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

//TODO: REFACTOR USING NEW FORM SYNTAX
class EditUser extends Component {
  constructor(){
    super();

    this.state = {
      avatar:null,
      activeRole:'owner',
      avatarId:null,
      avatarURL:null,
      avatarThumbnailURL:null,
      avatarFileName:null,
      isOwner:null,
      isViewingTermsAndConditions:false
    };
  }

  componentWillMount(){
    if(this.props.needsLoading && !this.props.isCreate && !this.props.isProfile){
      this.props.loadUser(this.props.userId);
    }

    if(this.props.existingUser && !this.props.existingUser.isOwner){
      this.setState({activeRole:'user'})
    }

    if(this.props.existingUser && this.props.existingUser.avatarId){
      this.setState({avatarId:this.props.existingUser.avatarId});
    }

    if(this.props.existingUser && this.props.existingUser.avatarURL){
      this.setState({avatarURL:this.props.existingUser.avatarURL});
    }

    if(this.props.existingUser && this.props.existingUser.avatarThumbnailURL){
      this.setState({avatarThumbnailURL:this.props.existingUser.avatarThumbnailURL});
    }

    if(this.props.existingUser && this.props.existingUser.avatarFileName){
      this.setState({avatarFileName:this.props.existingUser.avatarFileName});
    }
  }

  handleSubmit(data){
    data.isOwner = this.state.activeRole === 'owner';
    data.agencyId = this.props.activeUser.agencyId;
    data.avatarId = this.state.avatarId;
    data.avatarURL = this.state.avatarURL;
    data.avatarThumbnailURL = this.state.avatarThumbnailURL;
    data.avatarFileName = this.state.avatarFileName;

    if(this.props.isCreate){
      this.props.checkIfEmailTaken(data.email)
        .then((res) => this.props.createUser(data))
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    } else if(this.props.isUpdate){
      this.props.updateUser(this.props.userId,data)
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    } else if(this.props.isProfile){
      if(!this.props.activeUser.id ) throw new Error('Invalid user id');

      this.props.updateUser(this.props.activeUser.id,data)
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    }
  }

  handleSuccess(data){
    this.props.history.push(this.getBackURL());
  }

  handleFailure(err){}

  handlePictureChange(res){
    this.setState({
      avatar:res,
      avatarId:res.id,
      avatarURL:res.medium,
      avatarThumbnailURL:res.thumbnail,
      avatarFileName:res.fileName
    });
  }

  getSubmitButtonText(){
    if(this.props.isCreate){
      return 'Invite';
    } else if(this.props.isProfile){
      return 'Update';
    } else {
      return 'Update';
    }
  }

  getTitle(){
    if(this.props.isCreate){
      return 'Invite User';
    } else if(this.props.isProfile){
      return 'My Profile';
    } else {
      return 'Edit User';
    }
  }

  getBackURL(){
    if(this.props.isProfile){
      return urlRoot(this.props.match.url) + '/experiences';
    } else {
      return urlRoot(this.props.match.url) + '/users';
    }
  }

  renderHelp(){
    if(this.state.activeRole === 'owner'){
      return (
        <Alert color='info'>
          Create:&nbsp;&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Publish:&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Admin:&nbsp;&nbsp;&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
        </Alert>
      );
    } else if(this.state.activeRole === 'user'){
      return (
        <Alert color='info'>
          Create:&nbsp;&nbsp;<i className='fa fa-thumbs-o-up' aria-hidden='true'></i><br />
          Publish:&nbsp;<i className='fa fa-thumbs-o-down' aria-hidden='true'></i><br />
          Admin:&nbsp;&nbsp;&nbsp;<i className='fa fa-thumbs-o-down' aria-hidden='true'></i><br />
        </Alert>
      );
    } else {
      return (
        <Alert color='info'>
          Create:&nbsp;&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
          Publish:&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
          Admin:&nbsp;&nbsp;&nbsp;<i className='fa fa-hand-spock-o' aria-hidden='true'></i><br />
        </Alert>
      );
    }
  }

  render(){
    const {
      isCreate,
      isProfile,
      existingUser,
      needsLoading
    } = this.props;

    const { isViewingTermsAndConditions, avatarFileName, avatarURL } = this.state;

    const formReady = isCreate || (isProfile && !!existingUser) || (!needsLoading && !!existingUser);

    return (
      <Container>
        <Modal
          size='lg'
          isOpen={isViewingTermsAndConditions}
          toggle={() => this.setState({isViewingTermsAndConditions:!isViewingTermsAndConditions})}
        >
          <ModalHeader>
            Dabbl Terms and Conditions v1 (effective 10/31/17)
          </ModalHeader>
          <ModalBody>
            <AdjoyTermsAndConditions />
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => this.setState({isViewingTermsAndConditions:false})}>
              Ok
            </Button>
          </ModalFooter>
        </Modal>
        <Row>
          <Col xs='6'>
            <h1 style={{padding:'50px 0px'}}>{this.getTitle()}</h1>
          </Col>
        </Row>
        <Row>
          <Col xs='12' md='6'>
            {formReady ? (
              <Form
                key={existingUser ? existingUser.id : '__create__'}
                onSubmit={(data) => this.handleSubmit(data)}
              >
                {!isProfile && (
                  <Row>
                    <Col xs='6'>
                      <br />
                      <FormGroup>
                        <Label>Permissions</Label>
                        <Input
                          type='select'
                          defaultValue={(isCreate || existingUser.isOwner) ? 'owner' : 'user'}
                          onChange={(e) => this.setState({activeRole:e.target.value})}
                        >
                          <option value='owner'>Admin</option>
                          <option value='user'>Creator</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col xs='6'>
                      <br />
                      {this.renderHelp()}
                      <br />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label>First Name</Label>
                      <Input
                        name='firstName'
                        placeholder='John'
                        defaultValue={isCreate ? '' :existingUser.firstName}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col xs='6'>
                    <FormGroup>
                      <Label>Last Name</Label>
                      <Input
                        name='lastName'
                        placeholder='Doe'
                        defaultValue={isCreate ? '' :existingUser.lastName}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs='12'>
                    <FormGroup>
                      <Label>Role</Label>
                      <Input
                        name='title'
                        placeholder='Head of Security'
                        defaultValue={isCreate ? '' :existingUser.title}
                      />                        
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs='12'>
                    <FormGroup>
                      <Label>Email</Label>
                      <Input
                        name='email'
                        type='email'
                        // pattern={EMAIL_REGEX}
                        placeholder='jdoe@company.com'
                        defaultValue={isCreate ? '' :existingUser.email}
                        disabled={!isCreate}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {isProfile && (
                  <Row>
                    <Col xs='12'>
                      <DroppableFileInput 
                        label='Profile Picture'
                        fileType='image'
                        name='avatar'
                        text='Upload profile picture'
                        onChange={(res) => this.handlePictureChange(res)}
                        warning={''}
                        cropperAspectRatio={1/1}
                        existingFileName={avatarFileName}
                        existingFileURL={avatarURL}
                      />
                    </Col>
                  </Row>
                )}
                <br />
                <div className='clearfix'>
                  <Button isSubmit>
                    {this.getSubmitButtonText()}
                  </Button>
                  <div className='pull-right'>
                    <Button
                      linkHref={this.getBackURL()}
                      className='pull-right'
                      textColor='#666666'
                      borderColor='#cccccc'
                      backgroundColor='#ededed'
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
                {isProfile && (
                  <div>
                    <br />
                    <br />
                    <span 
                      className='FakeLink'
                      onClick={() => this.setState({isViewingTermsAndConditions:true})}
                    >
                      View Terms and Conditions
                    </span>
                  </div>
                )}
              </Form>
            ) : (
              <div>Loading...</div>
            )}
          </Col>
        </Row>
      </Container>
    )
  }
}

export default EditUser;



// WEBPACK FOOTER //
// ./src/routes/EditUserNew/components/EditUserNew.js